import { render, staticRenderFns } from "./TableSalesReceipt.vue?vue&type=template&id=60d1edd0"
import script from "./TableSalesReceipt.vue?vue&type=script&lang=js"
export * from "./TableSalesReceipt.vue?vue&type=script&lang=js"
import style0 from "./TableSalesReceipt.vue?vue&type=style&index=0&id=60d1edd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports